module.exports = __webpack_public_path__ + "img/120-55-floor.9b81bbf7.jpg";